//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import QfModalModels from "../../qf-modal-models";
import PropertiesUtils from "../../mixins/properties-utils";

export default {
    name: "QfPValues",
    components: { QfModalModels },
    mixins: [PropertiesUtils],
    props: ["value"],
    data() {
        return {
            localValue: null,
            showModal: false,
            actions: [
                { icon: "mdi-file-tree", handler: () => { this.openModel(); } },
                { icon: "mdi-close-circle", content: true, handler: () => { this.clearValue(); } }
            ]
        };
    },
    computed: {
        ...mapState("components", ["activeComponent"])
    },
    watch: {
        value: {
            handler(val) {
                this.localValue = val;
            },
            immediate: true
        },
        localValue(val) {
            this.$emit("input", val);
        }
    },
    methods: {
        openModel() {
            this.showModal = true;
        },
        clearValue() {
            this.__resetComponentModel(this.activeComponent, { values: true });
        },
        valuesUpdate(newData) {
            this.localValue = newData;
        }
    }
};
